module.exports = __webpack_public_path__ + "media/images/application/icons/icon-visa-423a311e3e72a931ce7d0a02c055d7f9.svg";